export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_b3aef13b-f596-4d0d-a8af-4fa0fa7ae7f3/artifacts/o5rk853q_Logo%20Passerelle%20Num%20Inc.png";

export const CONTACT = {
  phone: "514 443 8084",
  phoneHref: "tel:+15144438084",
  email: "contact@passerellenumerique.ca",
  city: "Montréal, Québec, Canada",
};

export const NAV_LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/services", label: "Services" },
  { to: "/secteurs", label: "Solutions par secteur" },
  { to: "/realisations", label: "Études de cas" },
  { to: "/blog", label: "Blog" },
  { to: "/a-propos", label: "À propos" },
  { to: "/contact", label: "Contact" },
];

export const SERVICES = [
  {
    slug: "sites-web",
    title: "Création de sites web",
    short: "Des sites premium qui convertissent",
    icon: "Globe",
    benefits: [
      "Design sur mesure aligné à votre marque",
      "Performance & SEO intégrés dès la conception",
      "Responsive mobile/tablette/desktop",
      "Sécurité et hébergement gérés",
    ],
    process: ["Découverte", "Design & maquettes", "Développement", "Lancement & SEO"],
    examples: ["Sites vitrine PME", "E-commerce", "Portails clients", "Plateformes SaaS"],
    faq: [
      { q: "Combien coûte un site web?", a: "De 2 500 $ pour un site vitrine à 25 000 $+ pour un e-commerce avancé." },
      { q: "Combien de temps?", a: "Entre 3 et 8 semaines selon la complexité." },
    ],
  },
  {
    slug: "seo",
    title: "SEO & référencement local",
    short: "Apparaître en premier sur Google",
    icon: "Search",
    benefits: ["Top 3 Google Maps", "Trafic organique mensuel", "Avis clients automatisés", "Audit technique complet"],
    process: ["Audit", "Optimisation on-page", "Google Business Profile", "Backlinks locaux"],
    examples: ["Restaurants", "Cliniques", "Cabinets professionnels", "Commerces locaux"],
    faq: [
      { q: "Combien de temps pour voir des résultats?", a: "Premiers résultats dès 30 jours, performance optimale à 90-180 jours." },
    ],
  },
  {
    slug: "publicite",
    title: "Publicité numérique",
    short: "Facebook, Instagram, Google Ads",
    icon: "Target",
    benefits: ["ROAS optimisé", "Audience qualifiée", "Landing pages dédiées", "Suivi de conversion avancé"],
    process: ["Stratégie", "Création publicités", "Lancement & A/B", "Optimisation continue"],
    examples: ["Acquisition leads B2B", "E-commerce", "Retargeting", "Génération RDV"],
    faq: [
      { q: "Budget minimum?", a: "Nous recommandons 800 $/mois en média pour un test sérieux." },
    ],
  },
  {
    slug: "automatisation-ia",
    title: "Automatisation IA",
    short: "Chatbots, CRM, WhatsApp, workflows",
    icon: "Bot",
    benefits: ["Réponses 24/7", "Qualification auto. des prospects", "Économie de temps massif", "Hausse du taux de conversion"],
    process: ["Audit des flux", "Conception bot/IA", "Intégrations", "Mesure ROI"],
    examples: ["Chatbot Messenger", "WhatsApp Business", "CRM HubSpot", "Workflows n8n"],
    faq: [
      { q: "Quel ROI attendre?", a: "En moyenne 18 h/semaine économisées par PME selon nos clients." },
    ],
  },
  {
    slug: "developpement",
    title: "Développement d'applications",
    short: "Web apps, portails, dashboards, SaaS",
    icon: "Code2",
    benefits: ["Architecture évolutive", "UX moderne", "Sécurité enterprise", "Code maintenable"],
    process: ["Cadrage", "Prototypage", "Sprints agiles", "Mise en production & MCO"],
    examples: ["Portails clients", "Dashboards BI", "Outils internes", "Produits SaaS"],
    faq: [
      { q: "Stack utilisée?", a: "React, Node, Python, PostgreSQL/Mongo, AWS — choix selon vos besoins." },
    ],
  },
];

export const SECTORS = [
  {
    slug: "restaurants",
    title: "Restaurants",
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200",
    problems: ["Réservations manquées", "Faible visibilité Google", "Pas de menu en ligne", "Difficulté à fidéliser"],
    solutions: ["Site + menu QR code", "SEO local Montréal", "Réservation automatique", "Programme fidélité IA"],
    benefits: ["+40% de réservations", "Top 3 Google Maps", "Réduction des appels", "Hausse du panier moyen"],
    caseStudy: "Restaurant montréalais: +52% de réservations en 90 jours.",
  },
  {
    slug: "salons-coiffure",
    title: "Salons de coiffure",
    image: "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?w=1200",
    problems: ["No-shows fréquents", "Agenda papier", "Manque d'avis", "Peu de nouveaux clients"],
    solutions: ["Prise de RDV en ligne", "Rappels SMS auto", "Avis Google automatisés", "Pubs Instagram ciblées"],
    benefits: ["-70% de no-shows", "Agenda toujours plein", "Notation 4.8+ étoiles"],
    caseStudy: "Salon Plateau: agenda complet 6 semaines à l'avance.",
  },
  {
    slug: "immigration",
    title: "Immigration",
    image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1200",
    problems: ["Dossiers complexes", "Suivi client difficile", "Saisie manuelle", "Site peu rassurant"],
    solutions: ["Portail client sécurisé", "Workflows documents", "CRM dossiers", "Site multilingue"],
    benefits: ["Économie 20h/sem", "Satisfaction client +", "Conversion site x2"],
    caseStudy: "Cabinet d'immigration: traitement de dossier divisé par 2.",
  },
  {
    slug: "immobilier",
    title: "Immobilier",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200",
    problems: ["Leads froids", "Visites manquées", "Site générique", "Pas de retargeting"],
    solutions: ["Landing pages par propriété", "Chatbot IA qualification", "Visites virtuelles", "Ads Meta/Google"],
    benefits: ["+3x leads qualifiés", "Cycle de vente raccourci", "Notoriété locale"],
    caseStudy: "Courtier Laval: 24 leads/mois → 87 en 4 mois.",
  },
  {
    slug: "cliniques",
    title: "Cliniques",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1200",
    problems: ["Patients qui ne reviennent pas", "Surcharge admin", "Manque de visibilité", "Aucun rappel auto"],
    solutions: ["Portail patient", "Rappels SMS/courriel", "SEO local santé", "Avis Google patients"],
    benefits: ["+30% de fidélisation", "Économie 25h/sem admin", "Top 1 Google"],
    caseStudy: "Clinique dentaire: 92% de présence aux RDV.",
  },
  {
    slug: "pme",
    title: "PME tous secteurs",
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200",
    problems: ["Manque de leads", "Trop de tâches manuelles", "Site obsolète", "Pas de stratégie data"],
    solutions: ["Site moderne + SEO", "Automatisations IA", "Dashboards BI", "Stratégie d'acquisition"],
    benefits: ["+50% de revenus 12 mois", "Équipe libérée", "Décisions basées sur la data"],
    caseStudy: "PME industrielle: revenus +63% sur 12 mois.",
  },
];

export const CASE_STUDIES = [
  {
    slug: "demkabiz",
    title: "DEMKABIZ",
    url: "https://demkabiz.com",
    category: "Plateforme communautaire & opportunités",
    description: "Hub tout-en-un connectant entrepreneurs, prestataires, investisseurs et particuliers de la communauté africaine au Canada et dans la diaspora. Annuaire, marketplace, offres d'emploi, événements et financement.",
    image: "https://customer-assets.emergentagent.com/job_digital-bridge-pme/artifacts/qj4u1is4_ChatGPT%20Image%201%20juin%202026%2C%2016_07_50.png",
    tags: ["Web", "Mobile", "Marketplace", "Communauté"],
  },
  {
    slug: "go-au-canada",
    title: "GO AU CANADA",
    url: "https://app.goaucanada.com",
    category: "Immigration & accompagnement",
    description: "Application mobile qui guide pas à pas étudiants, travailleurs et immigrants vers le Canada : parcours personnalisés, gestion documentaire, biométrie, suivi de demande et préparation du départ.",
    image: "https://customer-assets.emergentagent.com/job_digital-bridge-pme/artifacts/eihxiznv_GO%20AU%20CANADA%20APP.png",
    tags: ["App mobile", "Immigration", "UX", "Sécurité"],
  },
  {
    slug: "ndolo",
    title: "N'DOLO",
    url: "https://nodo.mboaplace.com",
    category: "Application de rencontres",
    description: "L'amour commence ici. Application de rencontres sérieuses dédiée à l'Afrique et à sa diaspora : matchs compatibles, profils vérifiés, discussions sécurisées et confidentialité par design.",
    image: "https://customer-assets.emergentagent.com/job_digital-bridge-pme/artifacts/2m8dp346_N-dolo%20l%27app%20de%20rencontre%20de%20la%20diaspora.png",
    tags: ["Dating", "iOS", "Android", "Sécurité"],
  },
  {
    slug: "mboa-send",
    title: "MBOA SEND",
    url: "https://app.mboasend.com",
    category: "Fintech · Transferts d'argent",
    description: "Plateforme de transfert d'argent rapide et sécurisée entre le Canada et le Cameroun. Réception sur MTN, Orange Mobile Money et plus, taux compétitifs et réseau d'agents partenaires.",
    image: "https://customer-assets.emergentagent.com/job_digital-bridge-pme/artifacts/cthdx4zx_MBOA%20SEND%20-Envoi%20de%20fond%20Canada%20-%20Cameroun.png",
    tags: ["Fintech", "Mobile Money", "KYC", "Paiements"],
  },
];

export const PROBLEMS = [
  { title: "Absence de site web professionnel", icon: "Globe2" },
  { title: "Faible visibilité Google", icon: "Search" },
  { title: "Trop de tâches manuelles", icon: "Cog" },
  { title: "Peu de prospects", icon: "Users" },
  { title: "Mauvaise gestion des rendez-vous", icon: "CalendarX" },
  { title: "Réponses clients trop lentes", icon: "Clock" },
  { title: "Manque d'automatisation", icon: "Workflow" },
  { title: "Publicités peu performantes", icon: "TrendingDown" },
];

export const SOLUTIONS = [
  {
    title: "Visibilité numérique",
    icon: "Eye",
    items: ["Site web", "SEO", "Google Business", "Google Maps"],
  },
  {
    title: "Acquisition de clients",
    icon: "Target",
    items: ["Facebook Ads", "Instagram Ads", "Google Ads", "Landing pages"],
  },
  {
    title: "Automatisation IA",
    icon: "Bot",
    items: ["Chatbots IA", "WhatsApp Business", "CRM", "Réponses automatiques"],
  },
  {
    title: "Développement sur mesure",
    icon: "Code2",
    items: ["Applications web", "Portails clients", "Dashboards", "Outils métier"],
  },
];

export const VALUES = [
  { title: "Innovation", desc: "Toujours à la pointe : IA, automatisation, web moderne." },
  { title: "Simplicité", desc: "Des solutions claires, sans jargon, qui livrent." },
  { title: "Performance", desc: "Mesurer le ROI, optimiser, livrer des résultats concrets." },
  { title: "Accompagnement", desc: "Un vrai partenaire à long terme, pas un simple prestataire." },
];

export const BLOG_CATEGORIES = [
  "Intelligence artificielle",
  "Marketing numérique",
  "SEO",
  "Automatisation",
  "PME",
];
